import React from 'react'

import { cn } from '@/lib/utils'

export type ToggleOption = {
  label: React.ReactNode
  value: string
}

type Props = {
  options: ToggleOption[]
  value: string | null
  onChange: (value: string) => void
  direction?: 'horizontal' | 'vertical'
  enabled?: boolean
  className?: string
}

export const ToggleMultiple = ({
  options = [],
  value = null,
  onChange,
  direction = 'vertical',
  enabled = true,
  className = '',
}: Props) => {
  return (
    <div
      className={cn(
        'flex gap-2',
        direction === 'horizontal' ? 'flex-row flex-wrap' : 'flex-col',
        className,
      )}
    >
      {options.map((option) => (
        <label
          key={option.value}
          className={cn(
            'flex flex-row items-center gap-2 px-2',
            enabled ? 'cursor-pointer' : 'pointer-events-none',
          )}
          htmlFor={option.value}
        >
          <input
            id={option.value}
            name={option.value}
            checked={option.value === value}
            type="radio"
            disabled={!enabled}
            value={option.value}
            className="m-0"
            style={{ minWidth: '16px', minHeight: '16px' }}
            onChange={() => {
              onChange(option.value)
            }}
          />
          <span className={cn('block grow', enabled ? '' : 'opacity-50')}>
            {option.label}
          </span>
        </label>
      ))}
    </div>
  )
}
